// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".div-info-nova-senha {\n  display: flex;\n  flex-direction: column;\n  font-size: 14px;\n  text-align: center;\n  margin-bottom: 10px;\n}", ""]);
// Exports
module.exports = exports;
